import { gql } from '@apollo/client';

export const GET_VIEW_RENEW_MOTOR_POLICY_VAR_DETAILS = gql`
  query viewRenewMotorPolicyAndIntermediary {
    viewRenewMotorPolicy @client
    selectedIntermediary @client
  }
`;

export const SEARCH_CUSTOMER_BY_NUMBER = gql`
  query searchCustomerByNumber($input: ViewCustInput) {
    customer(input: $input) {
      cust_number
      cust_ref_number
      cust_type {
        code
        value
      }
      bank_detail {
        name
        branch_name
        ifsc_code
        acc_number
        acc_holder
        micr_code
      }
      permanent_address {
        address_line1
        address_line2
        address_line3
        land_mark
        city
        district
        state
        pin_code
      }
      comm_equal_perm
      communication_address {
        address_line1
        address_line2
        address_line3
        land_mark
        city
        district
        state
        pin_code
      }
      indv_detail {
        title {
          code
          value
        }
        first_name
        middle_name
        full_name
        surname
        date_of_birth
        id_proof_type {
          code
          value
        }
        id_proof_number
        pan_card_number
        nationality {
          code
          value
        }
        occupation {
          code
          value
        }
        gender {
          code
          value
        }
        marital_status {
          code
          value
        }
        gst_number
        employeeNumber
        mother_maiden_name
        ckyc_id_number
        eia_required
        eia_number
      }
      org_detail {
        org_name
        org_type {
          code
          value
        }
        reg_number
        tan_number
        gst_number
        pan_card_number
        contact_mob
        contact_name
        contact_email
        ckyc_id_number
        udyog_aadhaar_number
        certificate_of_incorporation
      }
      contact {
        email
        mobile
        telephone
        fax_number
        alt_telephone
        alt_mobile
      }
    }
  }
`;

export const VIEW_PROPOSAL_TW = gql`
  query viewProposalTwoWheeler($input: viewProposalInput) {
    viewProposalTW(input: $input) {
      IMT23
      IMT34
      proposalNumber
      policyNumber
      tenure
      proposalStatus
      isApplicableForPayment
      UWCompleted
      premium {
        idv1
        idv3
        idv2
        tenure
        netODPremium
        netTPPremium
        loadingDiscount
        netPremium
        gst
        stampDuty
        totalPremium
        loading {
          name
          amount
        }
        discount {
          name
          amount
        }
        vehicleAge
        claimFreeYear
        creditScore
        warningMsg
        NCB
      }
      customerID
      product {
        productCode
        productName
      }
      productType
      businessType
      intermediaryDetails {
        code
        location
        fieldUserCode
        fieldUserName
      }
      rtoDetails {
        rtoAuthCode
        rtoLocCode
        rtoLocDesc
      }
      vehicleDetails {
        make {
          code
          value
        }
        model {
          code
          value
        }
        variant {
          code
          value
        }
        fuelType
        seatingCapacity
        cubicCapacity
        carryingCapacity
        GVW
        carriageType
        permitType
        vehicleUse
        manufactureYear
        regPurchaseDate
        engineNumber
        chasisNumber
        registrationNumber
        preInspectionNumber
        vehicleSegment
        registrationNumberOthers
      }
      sideCarValue
      minSideCarValue
      maxSideCarValue
      totalIDV
      bodyIDV
      firstYearIDV
      irf1
      isPreviousPolicy
      otherCoverDetails {
        isGeoAreaExtension
        isBangladeshCovered
        isBhutanCovered
        isMaldivesCovered
        isNepalCovered
        isPakistanCovered
        isSriLankaCovered
        isVehicleForHandicapped
        isGlassFuelTank
      }
      prevInsuranceDetails {
        insurerName
        policyNumber
        expiryDate
        startDate
        coverType
        policyTenure
      }
      prevInsuranceDetailsGCV {
        insurerName
        policyNumber
        expiryDate
        startDate
        coverType
        policyTenure
      }
      previousClaimsArray{
        totalClaimCount
        claimsInYear1
        claimsInYear2
        claimsInYear3
        prevNCBSlab
        totalClaimAmount
        claimFreeYear 
      }
      previousClaims {
        totalClaimCount
        claimsInYear1
        claimsInYear2
        claimsInYear3
        prevNCBSlab
        totalClaimAmount
        claimFreeYear
      }
      financerDetails {
        vehicleOwned
        financerName
        financerAddress
        financerAgreementType
        loanAccountNumber
        fileNumber
      }
      riskCovers {
        riskType
        covers {
          name
          index
          selected
          isRenewalSelected
          attributes {
            name
            value
            displayName
            fieldType
            fieldDataType
            defaultValue
            showOnScreen
            dataValues {
              code
              value
            }
          }
        }
      }
      creditScore {
        discountOpted
        idProofType
        idProofNumber
        creditScore
      }
      proposerPincode
      voluntaryDeductibleAmt
      quoteNumber
      nomineeDetails {
        relationship
        name
        dob
        relationshipWithInsured
        relationshipWithAppointee
        nameOfAppointee
      }
      leadGenerator
      proposalPaymentType
      policy {
        startDate
        endDate
        time
      }
      lob {
        lobCode
        lobName
      }
      userID
      minChangedIDV
      maxChangedIDV
      idvPctMax
      irfPctMax
      idvPctMin
      irfPctMin
      sideCarPct
      NCB
    }
  }
`;

export const PREVIOUS_POLICY_CLAIMS_DROPDOWN_DETAILS = gql`
  query previousPolicyDropdownDetails($productCode: StrictNumber) {
    PRD_PreviousPolicyTypeList(productCode: $productCode) {
      code
      value
    }
    PRD_PreviousPolicyTermList(productCode: $productCode) {
      code
      value
    }
    PRD_TotalClaimCountList(productCode: $productCode) {
      code
      value
    }
    PRD_NoOfClaimsInYear1List(productCode: $productCode) {
      code
      value
    }
    PRD_NoOfClaimsInYear2List(productCode: $productCode) {
      code
      value
    }
    PRD_NoOfClaimsInYear3List(productCode: $productCode) {
      code
      value
    }
    PRD_PreviousYearNCBSlabList(productCode: $productCode) {
      code
      value
    }
  }
`;

export const FINANCIER_NAME_LIST = gql`
  query getFinancierNameList($value: String) {
    getFinancierNameList(value: $value) {
      code
      value
    }
  }
`;
export const FINANCER_DROPDOWN_DETAILS = gql`
  query financerDetails($productCode: StrictNumber) {
    PRD_FinancerAgreementType(productCode: $productCode) {
      code
      value
    }
    PRD_IsYourVehicle(productCode: $productCode) {
      code
      value
    }
    PRD_IDProofTypeForCreditScoreList(productCode: $productCode) {
      code
      value
    }
  }
`;

export const APPLICABLE_COVERS = gql`
  query applicableCovers($input: ApplicableCoversInput) {
    applicableCovers(input: $input) {
      tenure
      riskCovers {
        riskType
        covers {
          name
          index
          selected
          attributes {
            name
            value
            displayName
            fieldType
            fieldDataType
            defaultValue
            showOnScreen
            dataValues {
              code
              value
            }
          }
        }
      }
    }
  }
`;

export const TWO_WHEELER_BUSINESS_TYPE = gql`
  query getTwoWheelerBusinessType($filter: BusinessTypeInput) {
    getTwoWheelerBusinessType(filter: $filter) {
      code
      value
    }
  }
`;

export const GET_CUSTOMER_TYPE_DOMAIN = gql`
  query getCustomerTypeDomain {
    customerTypeList {
      code
      value
    }
  }
`;

export const PROPOSAL_PAYMENT_TYPE_LIST = gql`
  query proposalPaymentType {
    ProposalPaymentTypeList {
      code
      value
    }
  }
`;

export const GET_DATE_TIME = gql`
  query getDateTime {
    datetimeValue {
      time
      date
    }
  }
`;

export const PINCODE_LOOKUP = gql`
  query customerAddress($filter: PincodeFilter) {
    pincodeInfo(filter: $filter) {
      cityCode
      city
      districtCode
      district
      pinCode
      pinCodeLocality
      stateCode
      state
      countryCode
      country
    }
  }
`;

export const CUSTOMER_DROPDOWN_DETAIL = gql`
  query customerIndividualDetail {
    salutationList {
      code
      value
      gender
    }
    genderList {
      code
      value
    }
    maritalStatusList {
      code
      value
    }
    occupationList {
      code
      value
    }
    nomineeRelationshipList {
      code
      value
    }
    idProofTypeList {
      code
      value
    }
    nationalityList {
      code
      value
    }
    organisationList {
      code
      value
    }
  }
`;

export const CALCULATE_PREMIUM_FOR_PROPOSAL_TW = gql`
  query pcvcalculatePremiumProposal($input: PCVProposalInput) {
    pcvcalculatePremiumProposal(input: $input) {
      idv1
      idv2
      idv3
      tenure
      netODPremium
      netTPPremium
      loadingDiscount
      netPremium
      gst
      stampDuty
      totalPremium
      loading {
        name
        amount
      }
      discount {
        name
        amount
      }
      vehicleAge
      claimFreeYear
      creditScore
      warningMsg
      NCB
    }
  }
`;

export const SEND_RENEWAL_EMAIL_TW = gql`
  mutation sendTWRenewalEmail(
    $input: TWRenewalInput
    $email: StrictEmail
    $ccEmailIds: [StrictEmail]
  ) {
    sendTWRenewalEmail(
      input: $input
      email: $email
      ccEmailIds: $ccEmailIds
    ) {
      message
      quoteNumber
    }
  }
`;

export const SEND_RENEWAL_SMS_TW = gql`
  mutation sendTWRenewalSMS(
    $input: TWRenewalInput
    $mobile: StrictNumber
    $alternateMobileNos: [StrictNumber]
    $whatsappNo: String
    $modes: [String]
  ) {
    sendTWRenewalSMS(
      input: $input
      mobile: $mobile
      alternateMobileNos: $alternateMobileNos
      whatsappNo: $whatsappNo
      modes: $modes
    ) {
      message
      quoteNumber
    }
  }
`;

export const SEND_RENEWAL_PDF_TW = gql`
  mutation sendTWRenewalPDF($input: TWRenewalInput) {
    sendTWRenewalPDF(input: $input) {
      base64Pdf
    }
  }
`;

export const GET_INTERMEDIARY_LIST = gql`
  query myIntermediaries {
    myIntermediaries {
      intermediaryName
      intermediaryCode
      isSelected
      businessLocations {
        code
        name
      }
    }
  }
`;

export const LOAD_USER_PROFILE = gql`
  query loadProfileData {
    checkAuth {
      userId
      organisation {
        associatedCoreEntity {
          type
          value
        }
      }
    }
    userMyDetail {
      userType {
        typeName
      }
    }
  }
`;

export const GET_FIELDUSER_LIST = gql`
  query getFiledUserByIMID($input: FiledUserByIMID) {
    getFiledUserByIMID(input: $input) {
      fieldUserCode
      fieldUserName
    }
  }
`;

// export const SUBMIT_RENEWAL_TW = gql`
//   mutation submitRenewal($input: TWRenewalInput) {
//     submitTWRenewal(input: $input) {
//       proposalNumber
//       proposalEndDate
//       proposalStatus
//       isApplicableForPayment
//       premium {
//         idv1
//         idv2
//         idv3
//         tenure
//         netODPremium
//         netTPPremium
//         loadingDiscount
//         netPremium
//         gst
//         stampDuty
//         totalPremium
//         loading {
//           name
//           amount
//         }
//         discount {
//           name
//           amount
//         }
//       }
//       customerID
//       warningMsg
//     }
//   }
// `;
export const SUBMIT_RENEWAL_TW = gql`
  mutation submitPCVRenewal($input: GCVRenewalInput) {
    submitPCVRenewal(input: $input) {
      proposalNumber
      proposalEndDate
      proposalStatus
      isApplicableForPayment
      VehicleInspectionNeeded
      premium {
        idv1
        idv2
        idv3
        tenure
        netODPremium
        netTPPremium
        loadingDiscount
        netPremium
        gst
        stampDuty
        totalPremium
        loading {
          name
          amount
        }
        discount {
          name
          amount
        }
      }
      customerID
      warningMsg
    }
  }
`;
export const MOBILE_NUMBER_STARTING_WITH = gql`
  query mobileNumberStartingWith {
    mobileNumberStartingWith {
      code
      value
    }
  }
`;
export const PROPOSER_DROPDOWN_DETAIL = gql`
  query getProposerDropdownList($productCode: StrictNumber) {
    PRD_OccupationList(productCode: $productCode) {
      code
      value
    }
    PRD_PreExistDiseaseWaitPeriod(productCode: $productCode) {
      code
      value
    }
    PRD_NomiRelationWithMemb(productCode: $productCode) {
      code
      value
    }
    PRD_ApointRelationWithMinNomi(productCode: $productCode) {
      code
      value
    }
    PRD_CumulativeBonus(productCode: $productCode) {
      code
      value
    }
  }
`;
